import { ReportService } from '../services/ReportService';

export function useReportService(): ReportService {
  return new ReportService(useApiClient(), useUserStore());
}
